import '@/plugins/processEnv';
import '@/plugins/element';
import '@/plugins/vue-mq';
import '@/assets/styles.scss';
import '@/assets/helpers.scss';

import Vue from 'vue';

import i18n from '@/plugins/vue-i18n';

import store from '@/store';
import router from '@/router';
import errorReporter from '@/utils/error-reporter';
import App from './app.vue';

Vue.config.productionTip = false;

// Installed before mount so boot-time failures are captured too.
errorReporter.install(Vue, router);
window.dataLayer = window.dataLayer || [];

new Vue({
  i18n,
  store,
  beforeCreate() {
    this.$store.dispatch('initStore');
  },
  router,
  render: h => h(App),
}).$mount('#app');
